export enum UserAvatarButtonSize {
    SMALL,
    MEDIUM,
    LARGE,
}
